import { Component, Inject, OnInit } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-new-app-update-snackbar',
  templateUrl: './new-app-update-snackbar.component.html',
  styleUrls: ['./new-app-update-snackbar.component.css']
})
export class NewAppUpdateSnackbarComponent implements OnInit {

  constructor(
    public snackBarRef: MatSnackBarRef<NewAppUpdateSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  updateNow() {
    this.snackBarRef.dismissWithAction();
  }
}
